import { SvgProps } from 'react-native-svg'
import DeFlag from './flags/de'
import EnFlag from './flags/en'
import EsFlag from './flags/es'
import FrFlag from './flags/fr'
import ItFlag from './flags/it'
import JaFlag from './flags/ja'
import PlFlag from './flags/pl'
import RuFlag from './flags/ru'
import TrFlag from './flags/tr'
import DvFlag from './flags/dv'

const flags = {
  de: DeFlag,
  en: EnFlag,
  es: EsFlag,
  fr: FrFlag,
  it: ItFlag,
  ja: JaFlag,
  pl: PlFlag,
  ru: RuFlag,
  tr: TrFlag,
  dev: DvFlag,
} as const

type SupportedFlags = keyof typeof flags

function isSupportedFlag(code: string): code is SupportedFlags {
  return Object.prototype.hasOwnProperty.call(flags, code)
}

interface Props extends SvgProps {
  code: string
}

export default function Flag({ code, ...props }: Props) {
  if (!isSupportedFlag(code)) {
    return null
  }
  const Component = flags[code]
  return <Component {...props} />
}
